import type { GenericLayout } from "@mm/metx-workbench.meteomatics.com";
import { toolFormControllerMapping } from "./ToolFormMapping";

/**
 * We're gradually migrating input forms to react-hook-form based components.
 * The function returns if the given layer is supported by the new react-hook-form based component.
 */
export function v2ToolFormSupported(layout: GenericLayout): boolean {
  return layout.type in toolFormControllerMapping.componentsById;
}
